<div class="left-side">
  <div class="text-column">
    <p class="tag">{{ 'onboarding.stepThree.tag' | translate }}</p>
    <p class="title">{{ 'onboarding.stepThree.title' | translate }}</p>
    <p class="lead">{{ 'onboarding.stepThree.lead' | translate }}</p>

    <div class="cards">
      <app-onboarding-info-card badgeColor="pink">
        <actee-icon
          slot="badge"
          name="actee-op"
        />
        <span slot="title">{{ 'onboarding.stepThree.cards.communities.title' | translate }}</span>
        <span slot="description">{{ 'onboarding.stepThree.cards.communities.description' | translate }}</span>
      </app-onboarding-info-card>
      <app-onboarding-info-card badgeColor="orange">
        <actee-icon
          slot="badge"
          name="site"
        />
        <span slot="title">{{ 'onboarding.stepThree.cards.sites.title' | translate }}</span>
        <span slot="description">{{ 'onboarding.stepThree.cards.sites.description' | translate }}</span>
      </app-onboarding-info-card>
    </div>
  </div>
</div>
<div class="right-side">
  <img
    ngSrc="/images/onboarding/step-3.svg"
    width="470"
    height="408"
    [alt]="'onboarding.stepThree.imageAlt' | translate"
  />
</div>
